import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiConstant } from '@shared/constants/api.constant';
import { UserType } from '@shared-features/enums/user-type.enum';
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { DateRangeType } from '@shared/enums/date-range-type.enum';
import { AccountStatement, AccountStatementCounts } from '@shared-features/models/account-statement.model';
import { AccountStatementStatus } from '@shared-features/enums/account-statement-status.enum';

@Injectable({
  providedIn: 'root',
})
export class AccountStatementsApiService {
  constructor(private baseAPI: ApiBaseService) {}

  getAccountStatements(
    userType: UserType,
    entityId: number,
    params: {
      offset: number;
      limit: number;
      searchTerm?: string;
      dateRangeType: DateRangeType;
      startFrom?: string;
      endAt?: string;
      transactionStatus?: AccountStatementStatus;
      isForExport?: boolean;
    }
  ): Observable<AccountStatement[]> {
    const url =
      userType === UserType.FLEET
        ? `${ApiConstant.GET_ACCOUNT_STATEMENT_FLEET}${entityId}`
        : `${ApiConstant.GET_ACCOUNT_STATEMENT_CUSTOMER}${entityId}`;
    return this.baseAPI
      .get(url, { params: filterNullEntity(params) })
      .pipe(map((res) => res.data as AccountStatement[]));
  }

  getAccountStatementCounts(
    userType: UserType,
    entityId: number,
    params: {
      offset: number;
      limit: number;
      searchTerm?: string;
      dateRangeType: DateRangeType;
      startFrom?: string;
      endAt?: string;
    }
  ): Observable<AccountStatementCounts> {
    const url =
      userType === UserType.FLEET
        ? ApiConstant.GET_ACCOUNT_STATEMENT_FLEET_COUNTS(entityId)
        : ApiConstant.GET_ACCOUNT_STATEMENT_CUSTOMER_COUNTS(entityId);
    return this.baseAPI.get(url, { params: filterNullEntity(params) }).pipe(map((res) => res.data as AccountStatementCounts));
  }
}
